import React, { useState } from "react";
import { Services } from "../../network/Services";
import AoUrl from "../../network/url";
import { getLoggedUserId } from "../../network/auditFields";

const FederalWayRefundForm = ({ 
  selectedUser, 
  setSelecteduser, 
  updateUser, 
  setToast, 
  subtenantId, 
  setuseLoader, 
  setSelectedUserData, 
  setshowUserForm,
  loadFederalWayOrderRecords
}) => {
  const [formData, setFormData] = useState({
    tenantName: '',
    unitNumber: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = async () => {
    if (isSubmitting) return;
    
    // Validation
    if (!formData.tenantName.trim()) {
      setToast({message: 'Please enter the tenant name', type: 'error'});
      return;
    }
    
    if (!formData.unitNumber.trim()) {
      setToast({message: 'Please enter the unit number', type: 'error'});
      return;
    }

    setIsSubmitting(true);
    setuseLoader(true);

    try {
      // Create tenant using the same API as FederalWay.js
      const jsonObj = {
        "tenantId": 0,
        "userId": "",
        "subtenantId": subtenantId,
        "tenantName": formData.tenantName,
        "unitNumber": formData.unitNumber,
        "upsertedBy": getLoggedUserId() || "Refund System",
        "isActive": true
      };

      const response = await Services.upsertTenantdata(jsonObj);
      
      if (response?.data?.data) {
        const tenantData = response.data.data;
        
        // Update selected user with the new tenant data
        setSelecteduser({
          userId: tenantData.userId,
          fullName: tenantData.tenantName,
          primaryEmail: '',
          primaryMobile: '',
          memberId: tenantData.userId,
          clientAuthSubsVMs: [],
          matNo: tenantData.unitNumber,
          loginUserId: tenantData.userId,
          clientUserId: tenantData.userId, // Add clientUserId for Federal Way Plaza orders
          contactStatus: 'Active',
          isUserActive: true,
          tenantName: tenantData.tenantName,
          unitNumber: tenantData.unitNumber,
          tenantId: tenantData.tenantId
        });

        setSelectedUserData({
          userId: tenantData.userId,
          fullName: tenantData.tenantName,
          primaryEmail: '',
          primaryMobile: '',
          memberId: tenantData.userId, // For new tenants, this will be a GUID, but that's expected
          loginUserId: tenantData.userId,
          clientUserId: tenantData.userId, // Add clientUserId for Federal Way Plaza orders
          tenantName: tenantData.tenantName,
          unitNumber: tenantData.unitNumber,
          tenantId: tenantData.tenantId
        });

        setToast({message: 'Tenant created successfully', type: 'success'});
        
        // Hide the form after successful creation
        setshowUserForm(false);
        
        // For Federal Way Plaza, try to load any existing order records for this tenant
        if (loadFederalWayOrderRecords) {
          loadFederalWayOrderRecords(tenantData);
        }
        
        // Reset form
        setFormData({
          tenantName: '',
          unitNumber: ''
        });
      }
    } catch (error) {
      console.error('Error creating tenant:', error);
      setToast({message: 'Failed to create tenant. Please try again.', type: 'error'});
    } finally {
      setIsSubmitting(false);
      setuseLoader(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6 mt-4">
      <h3 className="text-lg font-semibold mb-4">Add New Tenant</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Tenant Name<span className="text-red-600">*</span>
          </label>
          <input
            type="text"
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
            placeholder="Enter tenant name"
            value={formData.tenantName}
            onChange={(e) => handleChange('tenantName', e.target.value)}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Unit Number<span className="text-red-600">*</span>
          </label>
          <input
            type="text"
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
            placeholder="Enter unit number"
            value={formData.unitNumber}
            onChange={(e) => handleChange('unitNumber', e.target.value)}
          />
        </div>
      </div>
      <div className="w-full mt-4 flex justify-end">
        <button 
          className={`px-4 py-2 rounded-md text-white ${
            isSubmitting 
              ? 'bg-gray-400 cursor-not-allowed' 
              : 'bg-green-600 hover:bg-green-700'
          }`}
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Submitting...' : 'Submit'}
        </button>
      </div>
    </div>
  );
};

export default FederalWayRefundForm;